// Função para abrir o modal
function openPoliciesModal() {
    const modal = document.getElementById('myModal');
    modal.style.display = 'flex';

    // Resetar estados
    isLinkClicked = false;
    isCheckboxChecked = false;
    isScrolledToBottom = false;

    // Verificar scroll e atualizar
    setTimeout(checkScrollAndUpdate, 100); // Delay para garantir renderização completa
}

// Função para fechar o modal
function closePoliciesModal() {
    document.getElementById('myModal').style.display = 'none';
    const submitBtn = document.getElementById('submitBtn');
    if (submitBtn) submitBtn.disabled = true;
    const checkbox = document.getElementById('agreeCheckbox');
    if (checkbox) {
        checkbox.disabled = true;
        checkbox.checked = false;
    }
    const checkboxContainer = document.getElementById('checkboxContainer');
    if (checkboxContainer) checkboxContainer.classList.add('desabilitado');
    isLinkClicked = false;
    isScrolledToBottom = false;
    isCheckboxChecked = false;
}

// Fechar o modal ao clicar fora dele
window.onclick = function(event) {
    const modal = document.getElementById('myModal');
    if (event.target === modal) {
        closePoliciesModal();
    }
}

// Variáveis de estado
let isScrolledToBottom = false;
let isLinkClicked = false;
let isCheckboxChecked = false;
let linkExists = false;
let hasScroll = false;

// Verifica se o link existe
const privacyLink = document.getElementById('privacyLink');
if (privacyLink) {
    linkExists = true;
    privacyLink.addEventListener('click', function(e) {
        isLinkClicked = true;
        checkCheckbox();
        checkSubmitButton();
    });
}

// Elemento container do checkbox
const checkboxContainer = document.getElementById('checkboxContainer');
// const agreeCheckbox = document.getElementById('agreeCheckbox');
const sectionText = document.querySelector('.section-text-company');

// Função para verificar se o conteúdo tem scroll e atualizar estados
function checkScrollAndUpdate() {
    const modalContent = document.getElementById('modalContent');
    const checkbox = document.getElementById('agreeCheckbox');
    if (!modalContent || !checkbox) return;

    hasScroll = modalContent.scrollHeight > modalContent.clientHeight + 10; // Tolerância

    if (!hasScroll) {
        isScrolledToBottom = true;
    } else {
        isScrolledToBottom = (modalContent.scrollTop + modalContent.clientHeight >= modalContent.scrollHeight - 10);
    }

    checkCheckbox();
    checkSubmitButton();
}

// Função para habilitar/desabilitar o checkbox e gerenciar classe 'desabilitado'
function checkCheckbox() {
    const checkbox = document.getElementById('agreeCheckbox');
    if (!checkbox || !checkboxContainer) return;

    const shouldEnable = isScrolledToBottom && (!linkExists || isLinkClicked);
    checkbox.disabled = !shouldEnable;

    if (shouldEnable) {
        checkboxContainer.classList.remove('desabilitado');
    } else {
        checkboxContainer.classList.add('desabilitado');
    }
}

// Função para habilitar/desabilitar o botão Enviar
function checkSubmitButton() {
    const submitBtn = document.getElementById('submitBtn');
    if (!submitBtn) return;

    const shouldEnable = isScrolledToBottom && (!linkExists || isLinkClicked) && isCheckboxChecked;
    submitBtn.disabled = !shouldEnable;
}

// Listener de scroll
const modalContent = document.getElementById('modalContent');
if (modalContent) {
    modalContent.addEventListener('scroll', function() {
        const tolerance = 10;
        const atBottom = modalContent.scrollTop + modalContent.clientHeight >= modalContent.scrollHeight - tolerance;
        if (atBottom !== isScrolledToBottom) {
            isScrolledToBottom = atBottom;
            checkCheckbox();
            checkSubmitButton();
        }
    });
}

// Listener do checkbox
const agreeCheckbox = document.getElementById('agreeCheckbox');
if (agreeCheckbox) {
    agreeCheckbox.addEventListener('change', function() {
        isCheckboxChecked = this.checked;
        checkSubmitButton();
    });

    agreeCheckbox.addEventListener('click', function(e) {
        if (this.disabled) {
            e.preventDefault();
            highlightSection();
        }
    });
}

// Resize listener para recalcular scroll se a janela mudar
window.addEventListener('resize', function() {
    if (document.getElementById('myModal').style.display === 'flex') {
        checkScrollAndUpdate();
    }
});


// Função para destacar a seção de texto
function highlightSection() {
    if (!sectionText) return;
    sectionText.classList.add('highlight');
    setTimeout(() => {
        sectionText.classList.remove('highlight');
    }, 800);
}

// Listener no checkbox: se estiver desabilitado, aplica efeito
// if (agreeCheckbox) {
//     agreeCheckbox.addEventListener('click', function(e) {
//         if (this.disabled) {
//             e.preventDefault();
//             highlightSection();
//         }
//     });
// }


checkboxContainer.addEventListener('click', function(e) {
    if (agreeCheckbox.disabled) {
        e.preventDefault();
        e.stopPropagation();
        highlightSection();
    }
});
